import {createSlice} from '@reduxjs/toolkit'

import type {ContentHotel, Hotel} from '@findhotel/sapi'
import type {PayloadAction} from '@reduxjs/toolkit'

interface PendingEnable {
  hotelId: string
  component?: string
}

interface ToastData {
  hotel: ContentHotel | Hotel
  checkIn: string
  checkOut: string
  enabled: boolean
  shouldShowNavigationIcon: boolean
  alertsManagementUrl?: string
}

interface PriceWatchState {
  isHoldOutGroup: boolean
  /**
   * Stores the intent to enable Price Watch after the user finishes an
   * authentication flow (e.g. One-Time-Password) that does not reload the page.
   * Cleared as soon as the Price Watch is successfully created or the process
   * is aborted.
   */
  pendingEnable?: PendingEnable
  /**
   * Stores toast data to be displayed globally, independent of component lifecycle.
   * Used to show price watch feedback when the triggering component is unmounted.
   */
  toast?: ToastData
}

const initialState: PriceWatchState = {
  isHoldOutGroup: false
}

const {actions, reducer} = createSlice({
  name: 'priceWatch',
  initialState,
  reducers: {
    setHoldOutGroup(state, action: PayloadAction<boolean>) {
      state.isHoldOutGroup = action.payload
    },
    setPendingEnable(state, action: PayloadAction<PendingEnable>) {
      state.pendingEnable = action.payload
    },
    clearPendingEnable(state) {
      state.pendingEnable = undefined
    },
    showToast(state, action: PayloadAction<ToastData>) {
      state.toast = action.payload
    },
    clearToast(state) {
      state.toast = undefined
    }
  }
})

export default reducer

export const {
  setHoldOutGroup,
  setPendingEnable,
  clearPendingEnable,
  showToast,
  clearToast
} = actions
